import * as React from 'react';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";

export default class DetalleLiquidacionEditar extends React.Component {
    render = () => {
        const { liquidacion, isBorrador } = this.props;

        return (
            <div className="row">
            
                <div className="col-12 col-sm-6">
                    <ul className="list-group">
                        <li className="list-group-item">
                            <span className={`badge rounded-pill ${liquidacion.cantidadOrdenes === 0 ? "text-bg-secondary" : "text-bg-primary"}`}
                            >
                                {liquidacion.cantidadOrdenes} 
                                {liquidacion.cantidadOrdenes === 1 ? " Orden" : " Órdenes"}
                            </span>
                            <span className={`mx-2 badge rounded-pill ${liquidacion.cantidadNovedades === 0 ? "text-bg-secondary" : "text-bg-primary"}`}>
                                {liquidacion.cantidadNovedades} 
                                {liquidacion.cantidadNovedades === 1 ? " Novedad" : " Novedades"}
                            </span>
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">N° Liquidación: {liquidacion.idLiquidacion}</h5>
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">Seller: {liquidacion.razonSocialSeller}</h5>
                        </li>
                        <li className="list-group-item">
                            <h5 className="card-title">Fecha: {liquidacion.mostrarFecha}</h5>
                        </li>
                    </ul>

                    {isBorrador &&
                        <div className="alert alert-secondary my-2" role="alert">
                            Liquidación pendiente de confirmar
                        </div>
                    }
                </div>

                <div className="col-12 col-sm-6">
                    <ul className="list-group">
                        <li className="list-group-item">
                            Total Ordenes: <strong>${formatoDecimal(liquidacion.totalOrden)}</strong>
                        </li>
                        <li className="list-group-item">
                            Comision Neta: <strong>${formatoDecimal(liquidacion.comisionNeta)}</strong>
                        </li>
                        <li className="list-group-item">
                            Comision Total a Facturar: <strong>${formatoDecimal(liquidacion.comisionTotal)}</strong>
                        </li>
                        <li className="list-group-item">
                            Costo Fee Neto: <strong>${formatoDecimal(liquidacion.totalCostoFeeNeto)}</strong>
                        </li>
                        <li className="list-group-item">
                            Total Costo Fee: <strong>${formatoDecimal(liquidacion.totalCostoFee)}</strong>
                        </li>
                        <li className="list-group-item">
                            Total Novedades: <strong>${formatoDecimal(liquidacion.totalNovedades)}</strong>
                        </li>
                        <li className="list-group-item">
                            Neto: <strong>${formatoDecimal(liquidacion.totalLiquidacion)}</strong>
                        </li>
                    </ul>
                </div>

            </div>
        );
    }
}